export class ConfigurationService {
  public identityService = "";
  public userManagementService = "";
  public dashboardService = "";
  public eviewServiceInternalApi = "";
  public organizationApi = "";

  public version = "";

  public async init() {
    try {
      const result = await fetch("appConfig.json");
      const configuration = await result.json();
      this.identityService = configuration.eplanConfigService.services.identityservice;
      this.userManagementService = configuration.eplanConfigService.services["eplan-management-service"];
      this.dashboardService = configuration.eplanConfigService.services.dashboardservice;
      this.eviewServiceInternalApi = configuration.eplanConfigService.services["eviewservice-internal-api"];
      this.organizationApi = configuration.eplanConfigService.services["organization-api"];
      this.version = configuration.version;
    } catch (error) {
      console.error(error);
    }
  }
}

const configurationService = new ConfigurationService();
export default configurationService;
